import { ApiEpSocialAccount, FailureApi } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "ep.social_account.fresh_data";

type Response = Await<ReturnType<typeof ApiEpSocialAccount.retrieveFreshData>>;

export const useQuerySocialAccountFreshData = (
  id: number,
  options?: Omit<
    UseQueryOptions<Response, FailureApi, Response>,
    "queryKey" | "queryFn" | "select"
  >,
) =>
  useQuery<Response, FailureApi, Response>(
    [KEY, id],
    () => ApiEpSocialAccount.retrieveFreshData(id),
    options,
  );

useQuerySocialAccountFreshData.KEY = KEY;
